/** Default search params when navigating to leave request list */
export const LEAVE_LIST_SEARCH_DEFAULTS = {
  sortBy: undefined as string | undefined,
  sortOrder: undefined as "asc" | "desc" | undefined,
  status: undefined as string | undefined,
  offset: 0,
  limit: 20,
};

/** Default search params when navigating to overtime request list */
export const OT_LIST_SEARCH_DEFAULTS = {
  sortBy: undefined as string | undefined,
  sortOrder: undefined as "asc" | "desc" | undefined,
  status: undefined as string | undefined,
  offset: 0,
  limit: 20,
};

/** Payroll status labels (Lao) for display */
export const PAYROLL_STATUS_LABELS: Record<string, string> = {
  draft: "ຮ່າງ",
  confirmed: "ຢືນຢັນ",
  paid: "ຈ່າຍແລ້ວ",
};
